/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_SubtitleInputs */

const tr_kullanim_subtitle = /** @type {(inputs: Kullanim_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ platformunu kullanırken geçerli olan ticari ve hukuki şartlar. Abonelik, sorumluluk sınırları, fesih ve yetki hükümlerini içerir.`)
};

const en_kullanim_subtitle = /** @type {(inputs: Kullanim_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The commercial and legal terms that apply when using the ShopPanel™ platform. They cover subscription, limits of liability, termination and jurisdiction.`)
};

const de_kullanim_subtitle = /** @type {(inputs: Kullanim_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die kaufmännischen und rechtlichen Bedingungen, die bei der Nutzung der Plattform ShopPanel™ gelten. Sie umfassen Abonnement, Haftungsgrenzen, Kündigung und Gerichtsstand.`)
};

const ru_kullanim_subtitle = /** @type {(inputs: Kullanim_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коммерческие и юридические условия, действующие при использовании платформы ShopPanel™. Включают подписку, пределы ответственности, расторжение и подсудность.`)
};

/**
* | output |
* | --- |
* | "The commercial and legal terms that apply when using the ShopPanel™ platform. They cover subscription, limits of liability, termination and jurisdiction." |
*
* @param {Kullanim_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_subtitle = /** @type {((inputs?: Kullanim_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_subtitle(inputs)
	if (locale === "de") return de_kullanim_subtitle(inputs)
	if (locale === "ru") return ru_kullanim_subtitle(inputs)
	return tr_kullanim_subtitle(inputs)
});